import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

function ClockIcon({ size = 22 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <circle cx="14" cy="14" r="12" stroke="#38bdf8" strokeWidth="1.75"/>
      <line x1="14" y1="14" x2="14" y2="8" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round"/>
      <line x1="14" y1="14" x2="19" y2="17" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="14" cy="14" r="1.5" fill="#38bdf8"/>
    </svg>
  );
}

const NAV_ITEMS = [
  { label: 'Start',          path: '/home'      },
  { label: 'Zeitkonten',     path: '/dashboard' },
  { label: 'Zeitzuschläge', path: '/premium'   },
];

export default function Sidebar() {
  const { user, logout, isSuperAdmin } = useAuth();
  const navigate                       = useNavigate();
  const { pathname }                   = useLocation();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <aside className="dash-sidebar">
      <div
        className="sidebar-brand"
        role="button"
        tabIndex={0}
        onClick={() => navigate('/home')}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); navigate('/home'); } }}
      >
        <ClockIcon />
        <span className="brand-text">Kimai<strong>Assist</strong></span>
      </div>

      <nav className="sidebar-nav">
        {NAV_ITEMS.map(({ label, path }) => (
          <button
            key={path}
            className={`nav-item${pathname === path ? ' active' : ''}`}
            onClick={() => navigate(path)}
          >
            {label}
          </button>
        ))}
        {isSuperAdmin && (
          <button
            className={`nav-item${pathname === '/settings' ? ' active' : ''}`}
            onClick={() => navigate('/settings')}
          >
            Einstellungen
          </button>
        )}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user-pill">
          <span className="sidebar-user-avatar">{(user || 'U')[0].toUpperCase()}</span>
          <span className="sidebar-user-name">{user}</span>
        </div>
        <button className="sidebar-logout" onClick={handleLogout}>Abmelden</button>
      </div>
    </aside>
  );
}
